export default __webpack_public_path__ + "static/media/flowers-no-2.2595d1b9.mid";